import { defineMessages } from 'react-intl';

export default defineMessages({
    liveAtAddress: {
        id: 'quoteandbind.common.views.component.commonPriorAddressComponent.Have you lived at current address for more than 1 year?',
        defaultMessage: 'Have you lived at current address for more than 1 year?',
    }
});
